import { Card, Stack, Typography, useTheme } from '@mui/material';

import { CustomAvatar, CustomAvatarGroup } from '../custom-avatar';
import { StatusTag } from '../status-tag';
interface props {
  titleName?: string;
  subTitleHead?: string;
  subTitleValue?: any;
  actionTime?: string;
  actionHead?: string;
  actionValue?: string;
  actionSubValue?: string;
  status?: string;
  description?: string;
  image?: string;
  src?: string;
  subTitleAvatar?: Array<{ name: string }>;
  onClick?: () => void;
  isSelected?: boolean;
  rightImage?: string;
  hideAvatar?: boolean;
}

const InfoStatusCard = ({
  titleName,
  subTitleHead,
  subTitleValue,
  actionValue,
  actionHead,
  actionTime,
  status,
  description,
  actionSubValue,
  image,
  src,
  subTitleAvatar,
  isSelected,
  rightImage,
  hideAvatar,
  onClick,
}: props) => {
  const theme = useTheme();
  return (
    <>
      <Card
        sx={{
          borderRadius: '5px',
          margin: 1,
          m: 1.5,
          padding: '4px',
          height: 'auto',
          cursor: 'pointer',
          border: isSelected ? `1.5px solid ${theme.palette.primary.main}` : 'none',
        }}
        onClick={onClick}
      >
        <Stack justifyContent={'space-between'} direction={'row'} m={0.5}>
          <Stack flexDirection={'row'} gap={1} alignItems="center">
            {!hideAvatar && (
              <Stack>
                {image ? (
                  <CustomAvatar name={titleName} color="info" src={image} />
                ) : (
                  <CustomAvatar name={titleName} color="info" src={src} />
                )}
              </Stack>
            )}
            <Stack>
              <Stack> {titleName}</Stack>
              <Stack flexDirection={'row'} fontSize={{ md: 10, xs: 7 }} gap={0.5}>
                <Stack color={theme.palette.grey[600]}> {subTitleHead}</Stack>
                <Stack color={theme.palette.grey[600]}> {subTitleValue}</Stack>
              </Stack>
              {subTitleAvatar && (
                <Stack>
                  <CustomAvatarGroup max={4} size="tiny">
                    {subTitleAvatar?.map((member: any, index: number) => (
                      <CustomAvatar key={index} name={member} color="info" />
                    ))}
                  </CustomAvatarGroup>
                </Stack>
              )}
            </Stack>
          </Stack>
          <Stack justifyContent={'center'} alignItems={'center'}>
            {status ? (
              <StatusTag status={status ?? ''} />
            ) : (
              <img
                src={rightImage}
                style={{
                  objectFit: 'contain',
                  height: 'auto',
                  width: '60px',
                  alignItems: 'center',
                }}
              />
            )}
            {actionTime && (
              <Stack fontSize={12} direction={'row'} gap={0.5}>
                <Typography
                  variant="body2"
                  color={theme.palette.grey[600]}
                  fontSize={{ md: 10, xs: 7 }}
                >
                  {actionTime ?? actionHead}
                </Typography>
                <Typography
                  variant="body2"
                  fontSize={{ md: 10, xs: 7 }}
                  color={theme.palette.common.black}
                >
                  {actionSubValue}
                </Typography>
              </Stack>
            )}
            <Stack fontSize={12} fontWeight={600} direction={'row'} sx={{ mr: { md: 1 } }}>
              <Typography>
                {actionValue && (
                  <CustomAvatar
                    sx={{ mr: 0.5, fontSize: 10, height: 22, width: 22 }}
                    name={actionValue}
                    color="info"
                  />
                )}
              </Typography>
              <Typography variant="body2" fontSize={{ md: 14, xs: 12 }}>
                {actionValue}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          ml={0}
          mt={0.5}
          fontSize={10}
          width={'100%'}
          sx={{ textAlign: 'justify', padding: '4px' }}
        >
          {description}
        </Stack>
      </Card>
    </>
  );
};
export { InfoStatusCard };
